import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Textarea,
} from "@chakra-ui/react"

export function ModalObs({ pedido, obs }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Button onClick={onOpen} maxW="100px" size="sm" colorScheme="blue" w="100%">
        {obs?.substring(0, 5).concat("...")}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Observações da retificação de layout do pedido {pedido}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Textarea value={obs} readOnly size="sm" resize="none" w="100%" h="100%" minH="300px" maxH="500px" />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
